import { render, staticRenderFns } from "./ShoppingListDetails.vue?vue&type=template&id=1d5b0177&"
import script from "./ShoppingListDetails.vue?vue&type=script&lang=js&"
export * from "./ShoppingListDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports